// Copyright (c) 2016 Deere & Company

import './components-panel.scss';
import React, {PropTypes} from 'react';
import Accordion from '../../../shared/components/accordion';
import AddComponentForm from './add-component-form';
import Component from '@deere/cps-it.warranty-model-factory/lib/component';
import ComponentsItem from './components-item';
import DownloadToExcelForPanel from '../../../shared/components/download-to-excel-for-panel';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {exportToExcel} from '../../../shared/services/export-to-excel';

const ComponentsPanel = (props, context) => {

    const componentsList = props.components.map((component, index) =>
        <ComponentsItem
            canAddDeleteComponent={props.canAddDeleteComponent}
            component={component}
            key={index}
            onDelete={props.onDelete}
        />
    );

    const componentsPanelTitle = (
        <span className='components-title'>
            <FormattedMessage id='COMPONENTS'/>{` (${props.components.length})`}
        </span>
    );

    const downloadToExcelEl = props.components.length ? (
        <DownloadToExcelForPanel onDownload={() => exportToExcel(`/api/products/${props.pin}/components?export=EXCEL&language=${context.user.getLocale()}`)}/>) : null;

    const componentsPanelBody = (
        <div>
            {props.canAddDeleteComponent &&
                <AddComponentForm
                    component={props.component}
                    componentCodes={props.componentCodes}
                    onCreateComponent={props.onCreateComponent}
                    onInputChange={props.onInputChange}
                    onPartNumberBlur={props.onPartNumberBlur}
                    showAddComponentRow={props.showAddComponentRow}
                />
            }
            <div className='components-header'>
                <span className='serial-number-header'>
                    <FormattedMessage id='SERIAL_NUMBER'/>
                </span>
                <span className='component-header'>
                    <FormattedMessage id='COMPONENT'/>
                </span>
                <span className='code-header'>
                    <FormattedMessage id='CODE'/>
                </span>
                <span className='created-date-header'>
                    <FormattedMessage id='CREATED'/>
                </span>
                <span className='changed-header'>
                    <FormattedMessage id='DELETED'/>
                </span>
                <span className='changed-by-header'>
                    <FormattedMessage id='DELETED_BY'/>
                </span>
                <span className='delete-icon'/>
            </div>
            <div>
                {componentsList}
            </div>
        </div>
    );

    return (
        <Accordion
            accordionId='components-panel-accordion'
            body={componentsPanelBody}
            isExpanded={props.isExpanded}
            onClick={props.onClick}
            secondaryHeaderNode={downloadToExcelEl}
            title={componentsPanelTitle}
        />
    );

};

ComponentsPanel.displayName = 'ComponentsPanel';
ComponentsPanel.propTypes = {
    canAddDeleteComponent: PropTypes.bool.isRequired,
    component: PropTypes.instanceOf(Component).isRequired,
    componentCodes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    components: PropTypes.arrayOf(PropTypes.instanceOf(Component)).isRequired,
    isExpanded: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    onCreateComponent: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onInputChange: PropTypes.func.isRequired,
    onPartNumberBlur: PropTypes.func.isRequired,
    pin: PropTypes.string.isRequired,
    showAddComponentRow: PropTypes.bool.isRequired
};
ComponentsPanel.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default ComponentsPanel;



// WEBPACK FOOTER //
// ./src/product/details/components/components-panel.js